import { useRef } from 'react';
//@ts-expect-error module not typed
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { getChannelInstanceId, getGenericChannelId, getSenderIdFromMessage, convertRecipientToType } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getWAPhoneNumbersForMessage } from 'conversations-thread-data/whatsapp/public/operators';
import { jsx as _jsx } from "react/jsx-runtime";
const src = `${getFullUrl('app')}/messaging-embedded/${PortalIdParser.get()}/crm`;
const noop = () => {};
const TemplateSendModal = ({
  messageLimitData,
  handleClose,
  message,
  recipient,
  onSend
}) => {
  const channelInstanceId = getChannelInstanceId(message);
  const genericChannelId = getGenericChannelId(message);
  const senderId = getSenderIdFromMessage(message);
  const {
    senderPhoneNumber,
    recipientPhoneNumber
  } = getWAPhoneNumbersForMessage(message);
  const {
    actorId
  } = convertRecipientToType(recipient);
  const handleMessage = ({
    payload
  }) => {
    const hasSentTemplate = payload.type === 'TEMPLATE_SENT';
    if (onSend && hasSentTemplate) {
      onSend(message, {
        communicatorType: 'compose',
        options: {
          templateId: payload.templateId
        }
      });
    }
  };
  const uiModalRef = useRef(undefined);
  return /*#__PURE__*/_jsx(UIModalIFrame, {
    embeddedPassthruProps: {
      genericChannelId,
      recipientId: actorId,
      recipientPhoneNumber,
      channelInstanceId,
      senderPhoneNumber,
      senderId,
      templateInitiationType: 'TWENTY_FOUR_HR_REPLY',
      messageLimitData,
      usageVariant: 'crm'
    },
    appName: "Inbox",
    height: 700,
    name: "mmm-whatsapp-template-selector",
    use: "default",
    onClose: handleClose,
    onInitError: noop,
    onMessage: handleMessage,
    onReady: noop,
    onReadyError: noop,
    src: src,
    scrolling: true,
    width: 1300,
    ref: uiModalRef
  });
};
TemplateSendModal.displayName = 'TemplateSendModal';
export default TemplateSendModal;